export default __webpack_public_path__ + "static/colors-zeta-44283e8ef03d371abef34f69ca021e49.gif";